<template>
  <div class="about_us_layer">
    <div class="background"></div>
    <div class="background"></div>
    <div class="background"></div>
    <div class="background last"></div>
    <div class="page_1 align_center">
      <div class="contents_wrapper">
        <div class="limited_width_box">
          <div class="title main">
            <span class="text nowrap">Project</span>
            <span class="text nowrap">Management</span>
            <span class="text nowrap">Consulting</span>
            <span class="text nowrap">& Data</span>
            <span class="text nowrap">Visualization</span>
          </div>
          <div class="description main effect_line">
            <span class="text">
              JinGraphics is an unprecedented project management consulting company <span class="dark_sky__">in oil and gas industry</span>.
              We are specialized in providing optimized solutions for project managers to reach their goal.
              We deliver a broad range of services such as developing a customized management system with high 
              quality project data visualization.
            </span>
            <span class="line"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="page_2 align_center">
      <div class="contents_wrapper">
        <div class="limited_width_box">
          <div class="title main">
            <span class="text nowrap">Why</span>
            <span class="text nowrap">JinGraphics?</span>
          </div>
          <div class="description main text_line_end">
            We thrive on challenging a complicated matters and problems for providing most effective 
            solutions to satisfy the needs of our clients. With our services, it is possible that 
            project managers and members making adequate decision and enhancing understanding of a 
            project with full integration across discipline leaders.
          </div>
          <div class="section_wrapper balanced">
            <div class="section reliable">
              <div class="title">
                Reliable
              </div>
              <div class="description font_extendalble_1_5">
                With more than 20 years of experience of project management in oil & gas industry, 
                JinGraphics understands about obstacle and hindrance on a project from beginning 
                to end. Our fame and good references come from project managers who finished their 
                onshore and offshore projects successfully by using our sophisticated management 
                systems and services
              </div>
            </div>
            <div class="section different">
              <div class="title">
                Different
              </div>
              <div class="description font_extendalble_1_5">
                Our effort and endeavor are permeated in our products and services to jump over the 
                limits of management method. Unlike other management systems, our products and services 
                focus on successful project management at construction site for project team members. 
                We strive to implement new technique and technology into our management system to 
                improve the benefits for our clients.
              </div>
            </div>
            <div class="section flexible">
              <div class="title">
                Flexible
              </div>
              <div class="description font_extendalble_1_5">
                Change requests are inevitable in any project. JinGraphics' management system is very 
                flexible and customizable on any change requests. Our products and services help 
                project managers effectively and successfully manage any changes in a project.
              </div>
            </div>
            <div class="section cost_saving">
              <div class="title">
                Cost Saving
              </div>
              <div class="description font_extendalble_1_5">
                Our management system requires minimum staff levels and provides more detailed and various 
                reports. Also, by using our outsourcing service, it facilitates reducing cost without the 
                loss of productivity
              </div>
            </div>
            <div class="section accessible">
              <div class="title">
                24/7 Accessible on Web
              </div>
              <div class="description font_extendalble_1_5">
                All of our processed data, analyzed reports, and visualized materials are available to view 
                and download over the Ethernet which is accessible 24 hours and 7 days a week anywhere with 
                Internet connection.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_3 align_center">
      <div class="contents_wrapper">
        <div class="limited_width_box">
          <div class="title main">
            <span class="text nowrap">Our</span>
            <span class="text nowrap">Experiences</span>
          </div>
          <div class="description main">
            The projects we have successfully completed over the past 30 years are:
          </div>
          <div class="history">
            <div class="hist_item now slide5">
              <div class="year">2026 - Now</div>
              <div class="project">
                <span class="name">Golden Pass LNG project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (USA, Texas)</span>
              </div>
            </div>
            <div class="hist_item now slide4">
              <div class="year">2025 - Now</div>
              <div class="project">
                <span class="name">KASKIDA FPU Project</span>
                <span class="client font_extendalble_1_5">BP (Singapore)</span>
              </div>
            </div>            
            <div class="hist_item now slide3">
              <div class="year">2024 - Now</div>
              <div class="project">
                <span class="name">TRION FPU Project</span>
                <span class="client font_extendalble_1_5">Woodside (HHI, Korea)</span>
              </div>
            </div>
            <div class="hist_item slide2">
              <div class="year">2023 - 2025</div>
              <div class="project">
                <span class="name">CRISP Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (Singapore)</span>
              </div>
            </div>
            <div class="hist_item slide1">
              <div class="year">2022 - 2024</div>
              <div class="project">
                <span class="name">China1 HCCP Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (SEI, China)</span>
              </div>
            </div>
            <div class="hist_item one">
              <div class="year">2020 - 2023</div>
              <div class="project">
                <span class="name">Tortue FPSO Project</span>
                <span class="client font_extendalble_1_5">BP (COSCO, China)</span>
              </div>
            </div>
            <div class="hist_item two">
              <div class="year">2019 - 2021</div>
              <div class="project">
                <span class="name">MD2(Mad dog phase-2) FPU Project</span>
                <span class="client font_extendalble_1_5">BP (SHI, Korea)</span>
              </div>
            </div>
            <div class="hist_item three">
              <div class="year">2017 - 2020</div>
              <div class="project">
                <span class="name">TCO(Tengizchervoil) FGP</span>
                <span class="client font_extendalble_1_5">Chevron (DSME, Korea)</span>
              </div>
            </div>
            <div class="hist_item four">
              <div class="year">2015 - 2017</div>
              <div class="project">
                <span class="name">Sakhalin-1 Odoptu Stage II Onshore Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (HHI, Korea ~ Odoptu, Russia)</span>
              </div>
            </div>
            <div class="hist_item five">
              <div class="year"></div>
              <div class="project">
                <span class="name">Point Thomson Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (HHI, Korea - North Slope, Alaska)</span>
              </div>
            </div>
            <div class="hist_item six">
              <div class="year"></div>
              <div class="project">
                <span class="name">Hebron DES Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (HHI, Korea)</span>
              </div>
            </div>
            <div class="hist_item seven">
              <div class="year">2013 - 2016</div>
              <div class="project">
                <span class="name">Hebron UPM Topsides Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (HHI, Korea - Bull Arm, Canada)</span>
              </div>
            </div>
            <div class="hist_item eight">
              <div class="year"></div>
              <div class="project">
                <span class="name">Sakhalin-1 Chayvo Onshore Extension Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (DSME, Korea)</span>
              </div>
            </div>
            <div class="hist_item nine">
              <div class="year">2011 - 2013</div>
              <div class="project">
                <span class="name">Sakhalin-1 Arkutun-Dagi Topsides Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (DSME, Korea)</span>
              </div>
            </div>
            <div class="hist_item ten">
              <div class="year">2009 - 2011</div>
              <div class="project">
                <span class="name">Qatar Gas II Onshore Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (Ras Laffan, Qatar)</span>
              </div>
            </div>
            <div class="hist_item eleven">
              <div class="year">2005 - 2007</div>
              <div class="project">
                <span class="name">Sakhalin-1 OPF Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (HHI, Korea - Chayvo, Russia)</span>
              </div>
            </div>
            <div class="hist_item twelve">
              <div class="year">2003 - 2005</div>
              <div class="project">
                <span class="name">Sakhalin-1 ORLAN Project</span>
                <span class="client font_extendalble_1_5">ExxonMobil (HHI, Korea)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { ScrollMixin } from '@/mixins/scroll.mixin'

export default {
  name: 'about_us',
  mixins: [
    ScrollMixin
  ],
  computed: {
    ...mapState(['scale']),
  },
  mounted() {
    this.init()
    this.$emit('mounted', 'about_us')
  },
  methods: {
    init() {
      let ts = document.querySelectorAll('.about_us_layer .title.main span')
      ts.forEach(t => {
        t.innerHTML = t.textContent.replace(/\S/g, "<span class='letter' style='display: inline-block;'>$&</span>")
      })

      this.setScrollAnime([
        { 
          targets: [
            { name: '.about_us_layer .page_1 .title.main', items: '.about_us_layer .page_1 .title.main span', status: 'opened' },
            { name: '.about_us_layer .page_2 .title.main', items: '.about_us_layer .page_2 .title.main span', status: 'closed' },
            { name: '.about_us_layer .page_3 .title.main', items: '.about_us_layer .page_3 .title.main span', status: 'closed' },
          ], 
          in: {
            translateX: [40, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 750,
            delay: (el, i) => 15 * i
          },
          out: {
            translateX: [0, -40],
            translateZ: 0,
            opacity: [1, 0],
            easing: "easeOutExpo",
            duration: 750,
            delay: (el, i) => 15 * i
          }
        },
        { 
          targets: [
            { name: '.about_us_layer .page_1 .description.main', status: 'opened' },
            
            { name: '.about_us_layer .page_2 .description.main', status: 'closed' },
            { name: '.about_us_layer .page_2 .section_wrapper .reliable', status: 'closed' },
            { name: '.about_us_layer .page_2 .section_wrapper .different', status: 'closed' },
            { name: '.about_us_layer .page_2 .section_wrapper .flexible', status: 'closed' },
            { name: '.about_us_layer .page_2 .section_wrapper .cost_saving', status: 'closed' },
            { name: '.about_us_layer .page_2 .section_wrapper .accessible', status: 'closed' },

            { name: '.about_us_layer .page_3 .description.main', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.slide5', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.slide4', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.slide3', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.slide2', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.slide1', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.one', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.two', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.three', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.four', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.five', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.six', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.seven', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.eight', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.nine', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.ten', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.eleven', status: 'closed' },
            { name: '.about_us_layer .page_3 .hist_item.twelve', status: 'closed' },
          ], 
          in: {
            translateX: [100, 0],
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 2500
          },
          out: {
            translateX: -300,
            opacity: 0,
            easing: "easeOutExpo",
            duration: 2500
          }
        },
      ])
    },
    open() {
      let w = window.outerWidth
      let dgs = document.querySelectorAll('.about_us_layer .background').length
      let dgWidth = 5

      this.$anime.timeline({loop: false})
      .add({
        targets: '.about_us_layer .background',
        left: (el, i) => [w, i * dgWidth],
        duration: 1000,
        delay: (el, i) => 75 * i
      })
      .add({
        targets: '.about_us_layer .background.last',
        width: [dgWidth, w - (dgs-1) * dgWidth],
        easing: "easeOutExpo",
        duration: 500,
      })
      .add({
        targets: '.about_us_layer .background',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 10000
      })
      this.$anime({
        targets: '.about_us_layer .page_1 .title.main span',
        translateX: [40,0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: (el, i) => 1250 + 30 * i
      })
      this.$anime({
        targets: '.about_us_layer .page_1 .description.effect_line .text',
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: 2350
      })

      let elbox = document.querySelector('.about_us_layer .page_1 .description.main').getBoundingClientRect()
      // set scaled width
      w = parseInt(elbox.width / this.scale)

      this.$anime.timeline({loop: false})
      .add({
        targets: '.about_us_layer .page_1 .description.effect_line .line',
        scaleY: [0, 1],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 500,
        delay: 1500
      })
      .add({
        targets: '.about_us_layer .page_1 .description.effect_line .line',
        translateX: [0, w],
        easing: "easeOutExpo",
        duration: 750,
        delay: 100
      })
    },
    close() {
      window.scrollTo(0, 0)
      
      this.$anime({
        translateY: [0, -100],
        targets: '.about_us_layer',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 500
      })
      setTimeout(() => {
        this.$emit('closed', 'about_us')
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>
.about_us_layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;

  .background {
    position: fixed;
    top: 0;
    right: -35px;
    bottom: 0;

    width: 5px;
    background: rgba(0, 0, 0, .1);
  }

  .page_3 {
    .history {
      display: flex;
      flex-direction: column;

      margin: -2.5rem;
      padding-top: 3rem;

      .hist_item {
        display: flex;
        align-items: flex-start;
        margin: 2.5rem;

        .year {
          font-family: Tahoma, Geneva, Verdana, sans-serif;
          font-size: 78px;
          font-weight: 900;
          color: rgba(0, 0, 0, .15);
          min-width: 30rem;
          margin-right: 2.5rem;
        }
        .project {
          display: flex;
          flex-direction: column;

          padding-left: 3rem;
          border-left: solid 3px #fff;

          span {
            display: inline-block;
          }
          .name {
            font-size: 3rem;
            font-weight: 500;
          }
          .client {
            font-size: 1.5rem;
            font-weight: 500;
            color: rgba(255, 255, 255, .55);
          }
        }

        &.now {
          .year {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>